import React, { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { tablasRenta } from "@/lib/renta";

const numInput = "np-input py-1.5 text-sm";

// Tramos y créditos del Impuesto sobre la Renta, por año (empresa.renta_tablas).
export const RentaConfigCard = ({ empresa, onChange }) => {
  const tablas = tablasRenta(empresa);
  const years = Object.keys(tablas).sort();
  const [anio, setAnio] = useState(years[years.length - 1]);
  const actual = tablas[anio] || tablas[years[years.length - 1]];
  const sel = tablas[anio] ? anio : years[years.length - 1];

  const save = (tabla) => onChange({ ...tablas, [sel]: tabla });
  const setTramo = (i, k, v) => {
    const tramos = actual.tramos.map((t, j) => (j === i ? { ...t, [k]: v === "" ? (k === "hasta" ? null : 0) : Number(v) } : t));
    if (k === "hasta" && tramos[i + 1]) tramos[i + 1] = { ...tramos[i + 1], desde: v === "" ? 0 : Number(v) };
    save({ ...actual, tramos });
  };
  const addTramo = () => {
    const last = actual.tramos[actual.tramos.length - 1];
    const desde = Number(last?.hasta) || (Number(last?.desde) || 0) + 1;
    const tramos = actual.tramos.map((t, j) => (j === actual.tramos.length - 1 && t.hasta == null ? { ...t, hasta: desde } : t));
    save({ ...actual, tramos: [...tramos, { desde, hasta: null, tarifa: 0 }] });
  };
  const removeTramo = (i) => {
    const tramos = actual.tramos.filter((_, j) => j !== i);
    if (tramos.length) tramos[tramos.length - 1] = { ...tramos[tramos.length - 1], hasta: null };
    save({ ...actual, tramos });
  };
  const addAnio = () => {
    const nuevo = String(Number(years[years.length - 1]) + 1);
    onChange({ ...tablas, [nuevo]: JSON.parse(JSON.stringify(tablas[years[years.length - 1]])) });
    setAnio(nuevo);
  };

  return (
    <div className="space-y-4" data-testid="renta-config-card">
      <div className="flex items-center gap-2 flex-wrap">
        <label className="np-label mb-0">Año</label>
        <select className="np-input w-28" value={sel} onChange={e => setAnio(e.target.value)} data-testid="renta-anio-select">
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <button type="button" onClick={addAnio} className="np-btn np-btn-outline inline-flex items-center gap-1.5 text-sm" data-testid="renta-agregar-anio">
          <Plus size={14} /> Agregar año
        </button>
        <span className="text-[11px] text-secondary-c">Cada planilla usa la tabla del año de su período.</span>
      </div>
      <table className="w-full text-sm" data-testid="renta-tramos-table">
        <thead><tr className="text-left text-xs text-secondary-c"><th className="py-1">Desde ₡</th><th>Hasta ₡</th><th>Tarifa %</th><th></th></tr></thead>
        <tbody>
          {actual.tramos.map((t, i) => (
            <tr key={i}>
              <td className="pr-2 py-1"><input type="number" className={`${numInput} disabled:bg-[#F3F0E8]`} value={t.desde} disabled={i > 0} onChange={e => setTramo(i, "desde", e.target.value)} data-testid={`renta-tramo-${i}-desde`} /></td>
              <td className="pr-2">
                {i === actual.tramos.length - 1
                  ? <div className="text-xs text-secondary-c px-2">en adelante</div>
                  : <input type="number" className={numInput} value={t.hasta ?? ""} onChange={e => setTramo(i, "hasta", e.target.value)} data-testid={`renta-tramo-${i}-hasta`} />}
              </td>
              <td className="pr-2"><input type="number" step="0.01" className={numInput} value={t.tarifa} onChange={e => setTramo(i, "tarifa", e.target.value)} data-testid={`renta-tramo-${i}-tarifa`} /></td>
              <td>{actual.tramos.length > 1 && <button type="button" onClick={() => removeTramo(i)} className="np-btn np-btn-ghost p-1.5 text-error" data-testid={`renta-tramo-${i}-quitar`}><Trash2 size={14} /></button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button type="button" onClick={addTramo} className="np-btn np-btn-ghost inline-flex items-center gap-1.5 text-sm" data-testid="renta-agregar-tramo"><Plus size={14} /> Agregar tramo</button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div><label className="np-label">Crédito mensual por hijo (₡)</label>
          <input type="number" className="np-input" value={actual.credito_hijo} onChange={e => save({ ...actual, credito_hijo: Number(e.target.value) || 0 })} data-testid="renta-credito-hijo" /></div>
        <div><label className="np-label">Crédito mensual por cónyuge (₡)</label>
          <input type="number" className="np-input" value={actual.credito_conyuge} onChange={e => save({ ...actual, credito_conyuge: Number(e.target.value) || 0 })} data-testid="renta-credito-conyuge" /></div>
      </div>
    </div>
  );
};
